import { graphql } from 'react-relay';

import { commit } from '../../mutations/commit';

const mutation = graphql`
  mutation markAsPaidMutation($input: MarkAsPaidInput!, $storeId: ID!) {
    markAsPaid(input: $input) {
      invoice {
        id
      }
      storeLists {
        ...InvoiceList_storeLists @arguments(storeId: $storeId)
      }
      errors {
        key
        messages
      }
    }
  }
`;

const markAsPaid = (environment, params, args = {}) => {
  const { storeId } = params;
  return commit(environment, {
    mutation,
    variables: {
      input: params,
      storeId,
    },
    ...args,
  });
};

export default markAsPaid;
